
const patientRouter = [
    {
        path:'',
        name:'patient-index',
        redirect: '/patient/list'
    },{
        path:'list',
        name:'patient-list',
        component: () => import(/* webpackChunkName: "about" */ '../views/patient/list.vue')
    },{
        path:'create',
        name:'patient-create',
        component: () => import(/* webpackChunkName: "about" */ '../views/patient/create.vue')
    },{
        path:'detail/:id',
        name:'patient-detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/patient/detail.vue')
    },{
        path:'edit/:id',
        name:'patient-edit',
        component: () => import(/* webpackChunkName: "about" */ '../views/patient/edit.vue')
    }
    
]
export default patientRouter